export const sendModel = (data) => ({
    details: {
        additionalCommunicationMethods: {
            wantToBePortalCustomer: data?.customer,
        },
    },
});
